import { render, staticRenderFns } from "./ROTableExpeditionsFee.vue?vue&type=template&id=5a673bf0&scoped=true&"
import script from "./ROTableExpeditionsFee.vue?vue&type=script&lang=js&"
export * from "./ROTableExpeditionsFee.vue?vue&type=script&lang=js&"
import style0 from "./ROTableExpeditionsFee.vue?vue&type=style&index=0&id=5a673bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a673bf0",
  null
  
)

export default component.exports